import ButtonClose from "./Close";
import ButtonConfirm from "./Confirm";

export const buttonConfig = {
    "CLOSE": {
        component: ButtonClose,
        action: "Cancel",
    },
    "CONFIRM": {
        component: ButtonConfirm,
        action: 'Success'
    }

}